const COUNTRIES_STORE = 'selectedCountries';
export default class SelectedCountriesHandler {

	constructor() {
		this.countryCookieInformation = new Map();
        window.addEventListener('beforeunload', () => {
            this._persist();
        });
	}

    _persist(countriesMap) {
	    localStorage.setItem(COUNTRIES_STORE, JSON.stringify(countriesMap ?? this._getCountries()))
    }

    _getCountries() {
        const storedSelectedCountriesString = localStorage.getItem(COUNTRIES_STORE)
        const selectedCountriesMap = storedSelectedCountriesString ? JSON.parse(storedSelectedCountriesString): {}
        return selectedCountriesMap;
    }

    getCountriesArray() {
	    return Object.values(this._getCountries());
    }

	addCountry(country) {
        const selectedCountries = this._getCountries();
        if (selectedCountries[country._id]) return;
        selectedCountries[country._id] = country
        this._persist(selectedCountries)
    }

    removeCountry(country) {
        const selectedCountries = this._getCountries();
        if (!selectedCountries[country._id]) return;
        delete selectedCountries[country._id];
        this._persist(selectedCountries)
    }

    clearCountries() {
	    this._persist({})
    }
	getCountryCookieInformation() {
		return this.countryCookieInformation;
	}

	// setCountryCookieInformation(country) {
	//
	// 	this.countryCookieInformation.set(countryId, countryName);
	// }

	// clearCountryCookieInformation() {
	// 	this.countryCookieInformation.clear();
	// }

	getAllSelectedCountries() {
	    return this.getCountriesArray()
		// return this.getCookieValueByName('countriesSelected').split(',');
	}



}

